import React from "react";
import { useNavigate } from "react-router-dom";
import { removeToken } from "../utils/tokenUtils";

export default function Topbar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    removeToken();
    navigate("/admin/login");
  };

  return (
    <header className="topbar shadow-sm bg-white">
      <div className="d-flex align-items-center justify-content-between px-3 px-md-4 py-2">

        {/* Left */}
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-light border d-md-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#sidebarOffcanvas"
          >
            ☰
          </button>

          <h5 className="mb-0 fw-semibold text-primary">
            BSCPCR Dashboard
          </h5>
        </div>

        {/* Right */}
        <div className="d-flex align-items-center gap-3">
          <span className="text-muted small d-none d-md-block">
            {new Date().toLocaleDateString()}
          </span>

          <button
            className="btn btn-outline-danger btn-sm px-3"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>

      </div>
    </header>
  );
}
